export default "__VITE_PUBLIC_ASSET__b8c1c884__"